import { useEffect, useRef } from 'react'
import { useQueryParam, StringParam } from 'use-query-params'

import { isString } from '@app/typeGuards'
import { QUERY_PARAMS_KEY } from '@app/constants'

import type { UseTokenFromQueryParams, UseTokenFromQueryReturn } from './types'

export const useTokenFromQuery = ({ onAuthSuccess }: UseTokenFromQueryParams): UseTokenFromQueryReturn => {
  const isTokenCaughtRef = useRef(false)
  const [tokenQuery, setTokenQuery] = useQueryParam(QUERY_PARAMS_KEY.token, StringParam)

  useEffect(() => {
    if (isTokenCaughtRef.current) return

    if (isString(tokenQuery)) {
      isTokenCaughtRef.current = true

      setTokenQuery(null)

      onAuthSuccess?.(tokenQuery)
    }
  }, [tokenQuery])

  return tokenQuery
}
